import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import "./WhyHireMe.css";

function WhyHireMe() {
  return (
    <Container fluid className="why-hire-section">
      <Particle />
      <Container className="why-hire-shell">
        <section className="why-hire-hero">
          <h1>Why hire me?</h1>
          <p className="lede">
            A question we all have when we can do a lot more and lot better with AI. Here's my pitch.
          </p>
        </section>

        <section className="technical-section">
          <div className="section-header">
            {/* <h2>Technical</h2> */}
            <h4> Why hire you when we can vibe-code the app?</h4>
          </div>
          
          <div className="content-card">
            <p>
              I'm not going to lie. I am very <strong>AI Forward</strong>. I work with coding agents like Cursor and Codex most of the time. 
              I've been a programmer pre-ChatGPT and a very different developer in this era of coding agents.
            </p>
            <p>
              You can vibe-code most of the POCs in a weekend, at least ones without data or compliance issues.
              But building something great, something that scales, and something that matters requires more than just coding. It requires vision,
              clarity, and the ability to stick with it long enough to accomplish something meaningful.
            </p>
          </div>
        </section>

        <section className="mindset-section">
          <div className="section-header">
            <h2>What drives me and how I work?</h2>
          </div>

          <div className="mindset-content">
            <p>
              I like working in a company with a <strong>grand vision</strong>, solving an <strong>ambitious problem</strong> with <strong>great impact</strong>. 
              Scale and clarity of the vision is more important than the scale of the company.
            </p>
            <p>
              I’m obsessed with <strong>high-agency, hands-on</strong> work that’s close to real users: rapid experimentation,
              feedback-driven iterations, and tightening the loop until the product is genuinely great.
            </p>
            <p>
              I've been a big dreamer all my life, wanting to achieve great things, but have been critical of myself for not sticking 
              to one thing long enough to accomplish something great. <strong>That changes this year.</strong> Three things I'll conquer: 
              <strong>time, energy, and focus</strong>. Things I want to optimize: <strong>daily routine, health, relationships, and money</strong>.
            </p>
            <p>
              One thing I lacked in the past is <strong>clarity</strong>. That changes now. I've realized to do anything great, you need to be very clear on <strong>what you want and why you want it</strong>, and then 
              build a system that reflects your end-goals.
            </p>
            <p>
              I am a very <strong>experimental and curiosity-driven</strong>. I must be curious to ask good questions, and you need to ask good questions 
              to learn and grow. You need to be curious about something to stick to it long enough and build something meaningful.
            </p>
            <p>
              I have ~<strong>3+ years across software + applied ML</strong>, including early-stage 0→1 work where I owned systems that later scaled into core offerings.
              More recently I’ve been sharpening research + fundamentals through coursework and projects like <strong>TRTutor</strong> (Talker–Reasoner personalized math tutor)
              and <strong>SkepticJudge</strong> (task-agnostic agent evaluation), which deepened my bias toward robust evals and observability for agents.
            </p>
          </div>
        </section>

        <section className="mindset-section">
          <div className="section-header">
            <h2>What I’m looking for next (and what I’ll offer)</h2>
          </div>

          <div className="mindset-content">
            <p>
              I’m looking for a role that’s <strong>highly technical</strong>, <strong>close to users</strong>, and rewards ownership of outcomes:
              shipping, measuring, debugging, and iterating fast under real constraints.
            </p>
            <p>
              What I’ll bring: <strong>0→1 systems thinking</strong>, first-principles problem solving, an unusually strong <strong>bias for action</strong>,
              and the humility to learn quickly from feedback. If there’s a knowledge gap, I’ll close it.
            </p>
            <p>
              I have entrepreneurial ambitions, so I care about the reps that matter: talking to users, building the right thing, and making it reliable.
              I’m <strong>coachable</strong>, receptive to critical feedback, and I thrive with high-agency teammates.
            </p>
          </div>
        </section>

        <section className="why-hire-cta">
          <div className="cta-content">
            <h2>Let's Build Something Great Together</h2>
            <p>If you're working on something ambitious with a clear vision, let's talk.</p>
          </div>
          <div className="cta-actions">
            <a 
              href="https://www.linkedin.com/in/varshini-balaji-132707154/" 
              target="_blank" 
              rel="noreferrer"
              className="cta-btn primary"
            >
              Get in Touch
            </a>
            <a href="/about" className="cta-btn secondary">
              Learn More About Me
            </a>
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default WhyHireMe;
